import type { SelectedLineItem } from "@/redux/slices/estimation.slice";

export const getKeyForMultiSelect = (selectedItem: SelectedLineItem) =>
  `${selectedItem.pageId}---${selectedItem.tupleId}---${selectedItem.lineItemId}---${selectedItem.lineItem}`;
import { ImagesDatabase } from "@/components/ImageCrop";
import type { CroppedRegion } from "@/interfaces/estimate-detail";
import { getStorageFileUrl } from "@/util/get-storage-file-url";

export const generateCanvasAndDrawRegions = async (
  remotePath: string,
  regions: CroppedRegion[],
): Promise<HTMLCanvasElement | undefined> => {
  const filePath = getStorageFileUrl(remotePath);
  const image = await ImagesDatabase.getInstance().getImage(filePath);

  const canvas = document.createElement("canvas");
  canvas.width = (image as unknown as HTMLImageElement).width;
  canvas.height = (image as unknown as HTMLImageElement).height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  ctx.drawImage(
    image as unknown as HTMLImageElement,
    0,
    0,
    (image as unknown as HTMLImageElement).width,
    (image as unknown as HTMLImageElement).height,
  );
  // Draw all regions
  regions.forEach((region) => {
    if (region.width > 0 && region.height > 0) {
      ctx.fillStyle = "rgba(254, 240, 138, 0.3)";
      ctx.fillRect(region.left, region.top, region.width, region.height);
      ctx.strokeStyle = "rgba(254, 240, 138, 0.9)";
      ctx.lineWidth = 3;
      ctx.strokeRect(region.left, region.top, region.width, region.height);
    }
  });

  return canvas;
};
